<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <div class="card mb-3">
        <div class="card-header">
          <fa-icon [icon]="['fas', 'gavel']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>Uppgifter om {{ arende.arendeTyp.namn | lowercase }}
        </div>
        <div class="card-body">
          <a *ngIf="arende.anstallda.length>=10" [routerLink]="['/mina-arenden']" [queryParams]="{ previous: arende.id }" class="btn-garanti btn-blue mb-3"><fa-icon [icon]="['fas', 'arrow-left']" class="me-2"></fa-icon>Tillbaka till Mina ärenden</a>
          <p class="h5">{{ arende.galdenar.orgnr }} {{ arende.galdenar.namn }}</p>
          <ul class="list-unstyled">
            <li>
              {{ arende.arendeTyp.typ==='rek' ? 'Beslutsdag' : 'Konkursdag' }}
              <ul class="list-unstyled ms-3">
                <li>
                  <b>{{ arende.beslutsdag | localizeddate:'shortDate' }}</b>
                </li>
              </ul>
            </li>
            <li class="mt-2" *ngIf="!!arende.forvaltare">
              {{ arende.arendeTyp.typ==='rek' ? 'Företagsrekonstruktör' : 'Konkursförvaltare' }}
              <ul class="list-unstyled ms-3">
                <li>
                  <b>{{ arende.forvaltare.fornamn }} {{ arende.forvaltare.efternamn }}</b>
                </li>
                <li *ngIf="arende.forvaltare.telefon">
                  <fa-icon [icon]="['fas', 'phone']" size="sm" class="me-2"></fa-icon><a [href]="'tel:' + arende.forvaltare.telefon">{{ arende.forvaltare.telefon }}</a>
                </li>
                <li *ngIf="arende.forvaltare.epost">
                  <fa-icon [icon]="['fas', 'at']" size="sm" class="me-2"></fa-icon><a [href]="'mailto:' + arende.forvaltare.epost">{{ arende.forvaltare.epost | lowercase }}</a>
                </li>
              </ul>
            </li>
            <li class="mt-2" *ngIf="!!arende.huvudHandlaggareEntitet">
              Kontaktperson
              <ul class="list-unstyled ms-3">
                <li>
                  <b>{{ arende.huvudHandlaggareEntitet.namn }}</b>
                </li>
                <li *ngIf="arende.huvudHandlaggareEntitet.telefon">
                  <fa-icon [icon]="['fas', 'phone']" size="sm" class="me-2"></fa-icon><a [href]="'tel:' + arende.huvudHandlaggareEntitet.telefon">{{ arende.huvudHandlaggareEntitet.telefon }}</a>
                </li>
                <li *ngIf="arende.huvudHandlaggareEntitet.epost">
                  <fa-icon [icon]="['fas', 'at']" size="sm" class="me-2"></fa-icon><a [href]="'mailto:' + arende.huvudHandlaggareEntitet.epost">{{ arende.huvudHandlaggareEntitet.epost | lowercase }}</a>
                </li>
              </ul>
            </li>
            <li class="mt-2" *ngIf="!!arende.lansstyresle">
              Länsstyrelse
              <ul class="list-unstyled ms-3">
                <li>
                  <b>{{ arende.lansstyresle?.namn }}</b> (utbetalande myndighet)
                </li>
              </ul>
            </li>
            <li class="mt-2" *ngIf="!!arende.tingsratt">
              Tingsrätt
              <ul class="list-unstyled ms-3">
                <li>
                  <b>{{ arende.tingsratt.namn }}</b>, {{ arende.arendenummer }}
                </li>
              </ul>
            <li class="mt-2" *ngIf="!!arende.not1 || !!arende.not2 || !!arende.not3">
              Noter/kommentarer
              <ul class="list-unstyled ms-3">
                <li class="badge rounded-pill badge-notis" *ngIf="!!arende.not1">{{ arende.not1 }}</li>
                <li class="badge rounded-pill badge-notis" *ngIf="!!arende.not2">{{ arende.not2 }}</li>
                <li class="badge rounded-pill badge-notis" *ngIf="!!arende.not3">{{ arende.not3 }}</li>
              </ul>
            </li>
          </ul>
          <div class="alert alert-light" *ngIf="!!arende.kommentar"><pre>{{ arende.kommentar }}</pre></div>

          <button type="button" class="btn-garanti btn-pink" (click)="scrollToTable('b2or')" *ngIf="arende.b2Beslut.length && arende.anstallda.length>=10"><fa-icon [icon]="['fas', 'arrow-down']" class="me-2"></fa-icon>Gå till {{ arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:orna</button>

          <hr />
          <p class="h5">Anställda</p>

          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                  <fa-icon [icon]="['fas', 'filter']" [fixedWidth]="true"></fa-icon>
                </span>
              <input [(ngModel)]="filterText" type="text" name="filter" class="form-control rounded-end" placeholder="Filtrera..." (ngModelChange)="applyFilter()">
            </div>
          </div>

          <div class="table-responsive" *ngIf="arende.anstallda.length">
            <table class="table table-hover" id="anstallda">
              <thead>
                <tr>
                  <th scope="col" class="d-none d-lg-table-cell" style="width:45px">
                  </th>
                  <th scope="col" [class.order-active]="anstalldaOrderName==='fornamn'" (click)="setAnstalldaOrder('fornamn', ['arbetstagare.fornamn'])">
                    <div class="d-flex justify-content-between">
                      Förnamn
                      <fa-icon [icon]="['fas', anstalldaReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="anstalldaReverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="anstalldaOrderName==='efternamn'" (click)="setAnstalldaOrder('efternamn', ['arbetstagare.efternamn'])">
                    <div class="d-flex justify-content-between">
                      Efternamn
                      <fa-icon [icon]="['fas', anstalldaReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="anstalldaReverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="anstalldaOrderName==='personNr'" (click)="setAnstalldaOrder('personNr', ['arbetstagare.personNr12Siffror'])">
                    <div class="d-flex justify-content-between">
                      Personnr
                      <fa-icon [icon]="['fas', anstalldaReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="anstalldaReverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" class="text-right-sm-left" [class.order-active]="anstalldaOrderName==='lg'" (click)="setAnstalldaOrder('lg', ['totalLgBelopp'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', anstalldaReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="me-2" [flip]="anstalldaReverse||'vertical'"></fa-icon>
                      Lönegaranti
                    </div>
                  </th>
                  <th scope="col" class="text-right-sm-left" [class.order-active]="anstalldaOrderName==='fordran'" (click)="setAnstalldaOrder('fordran', ['totalFordranBelopp'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', anstalldaReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="me-2" [flip]="anstalldaReverse||'vertical'"></fa-icon>
                      Fordran
                    </div>
                  </th>
                  <th scope="col" *ngIf="role === 'hl'">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', 'user-secret']" class="me-2"></fa-icon>
                      Visa som anställd
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let an of arende.anstallda | orderBy: anstalldaOrder:anstalldaReverse:'case-insensitive' | filterBy: userFilter" [routerLink]="['/anstallning', an.id]">
                  <td data-name="Kön" class="d-none d-lg-table-cell">
                    <arbetstagare-icon [arbetstagare]="an.arbetstagare" size="lg"></arbetstagare-icon>
                  </td>
                  <td data-name="Förnamn" title="Förnamn"><span [class.redacted]="an.isConfidential">{{ an.arbetstagare.fornamn }}</span></td>
                  <td data-name="Efternamn" title="Efternamn"><span [class.redacted]="an.isConfidential">{{ an.arbetstagare.efternamn }}</span></td>
                  <td data-name="Personnr." title="Personnummer">{{ an.arbetstagare.personNr12Siffror }}</td>
                  <td data-name="Lönegaranti" title="Lönegaranti i kronor" class="text-right-sm-left" [ngClass]="{ 'lg-over-max': an.totalLgBelopp > arende.lgMaxBelopp }">{{ an.totalLgBelopp | localizednumber }} kr</td>
                  <td data-name="Fordran" title="Fordran i kronor" class="text-right-sm-left" [ngClass]='{ "fordran-lg-diff": an.totalLgBelopp !== an.totalFordranBelopp && an.totalFordranBelopp > 0 }'>{{ an.totalFordranBelopp | localizednumber }} kr</td>
                  <td data-name="Visa som anställd" class="text-right-sm-left" *ngIf="role === 'hl'">
                    <button type="button"
                            class="btn btn-sm btn-outline-secondary"
                            (click)="visaSomAnstalld(an); $event.stopPropagation()">
                      <fa-icon [icon]="['fas', 'eye']"></fa-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot *ngIf="(arende.anstallda | filterBy: userFilter).length > 1">
                <tr>
                  <th class="d-none d-lg-table-cell"></th>
                  <th data-name="Anställda" title="Antal anställda i ärendet" colspan="3">{{ (arende.anstallda | filterBy: userFilter).length | localizednumber }} st</th>
                  <th data-name="Total lönegaranti" title="Total lönegaranti i ärendet i kronor" class="text-right-sm-left">{{ getSum(arende.anstallda | filterBy: userFilter, 'totalLgBelopp') | localizednumber }} kr</th>
                  <th data-name="Total fordran" title="Total fordran i ärendet i kronor" class="text-right-sm-left">{{ getSum(arende.anstallda | filterBy: userFilter, 'totalFordranBelopp') | localizednumber }} kr</th>
                </tr>
              </tfoot>
            </table>
          </div>
          <p class="text-muted" *ngIf="arende.anstallda.length && !(arende.anstallda | filterBy: userFilter).length">Inga träffar</p>
          <p class="text-muted" *ngIf="!arende.anstallda.length">Inga anställda</p>

          <button type="button" class="btn-garanti btn-pink mt-2" (click)="scrollToTable('anstallda')" *ngIf="arende.anstallda.length >= 10"><fa-icon [icon]="['fas', 'arrow-up']" class="me-2"></fa-icon>Gå till anställningarna</button>
          <hr />

          <p class="h5">{{ arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:or / Samlingsbeslut</p>
          <div class="table-responsive" *ngIf="arende.b2Beslut.length">
            <table class="table table-hover" id="b2or">
              <thead>
                <tr>
                  <!-- datum, antal arbetstagare, period, total, netto, dokument, signatur -->
                  <th scope="col" [class.order-active]="b2BeslutOrderName==='datum'" (click)="setB2BeslutOrder('datum', ['datum'])">
                    <div class="d-flex justify-content-between">
                      Datum
                      <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th class="text-right-sm-left" scope="col" [class.order-active]="b2BeslutOrderName==='antalArbetstagare'" (click)="setB2BeslutOrder('antalArbetstagare', ['antalArbetstagare'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                      Arbetstagare
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="b2BeslutOrderName==='period'" (click)="setB2BeslutOrder('period', ['periodFrom', 'periodTom'])">
                    <div class="d-flex justify-content-between">
                      Period
                      <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th class="text-right-sm-left" scope="col" [class.order-active]="b2BeslutOrderName==='lgBeloppTotal'" (click)="setB2BeslutOrder('lgBeloppTotal', ['lgBeloppTotal'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                      Lönegaranti
                    </div>
                  </th>
                  <th class="text-right-sm-left" scope="col" [class.order-active]="b2BeslutOrderName==='lgBeloppNetto'" (click)="setB2BeslutOrder('lgBeloppNetto', ['lgBeloppNetto'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                      Nettobelopp
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="b2BeslutOrderName==='dokument'" class="dokument-col" (click)="setB2BeslutOrder('dokument', ['harFil'])">
                    <div class="d-flex justify-content-between">
                      Dokument
                      <fa-icon [icon]="['fas', b2BeslutReverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="b2BeslutReverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" class="text-center-sm-left" style="width: 160px">
                    Signatur
                  </th>
                  <th scope="col" class="text-center-sm-left" *ngIf="role==='adv'" style="width: 45px">
                    Vald
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let b2 of arende.b2Beslut | orderBy: b2BeslutOrder:b2BeslutReverse:'case-insensitive'">
                  <td data-name="Datum" title="Datum" [routerLink]="['/huvud-b2', b2.id]">{{ b2.datum | localizeddate:'shortDate' }}</td>
                  <td data-name="Arbetstagare" title="Antal arbetstagare i {{ arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:an" class="text-right-sm-left" [routerLink]="['/huvud-b2', b2.id]">{{ b2.antalArbetstagare | localizednumber }} st</td>
                  <td data-name="Period" title="Period" [routerLink]="['/huvud-b2', b2.id]">{{ b2.periodFrom | localizeddate:'shortDate' }} &ndash; {{ b2.periodTom | localizeddate:'shortDate' }}</td>
                  <td data-name="Lönegaranti" title="Lönegaranti i kronor" class="text-right-sm-left" [routerLink]="['/huvud-b2', b2.id]">{{ b2.lgBeloppTotal | localizednumber }} kr</td>
                  <td data-name="Nettobelopp" title="Nettobelopp i kronor" class="text-right-sm-left" [routerLink]="['/huvud-b2', b2.id]">{{ b2.lgBeloppNetto | localizednumber }} kr</td>
                  <td data-name="Dokument" *ngIf="b2.filer.length" class="dokument-col">
                    <file-link [file]="b2.fil || b2.filer[0]" [caption]="(b2.fil || b2.filer[0])?.beskrivning || (b2.fil || b2.filer[0])?.filnamn"></file-link>
                    <div class="mt-3" *ngIf="b2.filer.length > 1">
                      <button type="button" (click)="showAttachments(b2)" class="btn btn-link" style="padding:0" title="Beslutets bilagor"><fa-icon [icon]="['fas', 'copy']" [fixedWidth]="true" size="lg" class="me-2"></fa-icon>Bilagor ({{ b2.filer.length - 1 }})</button>
                    </div>
                  </td>
                  <td data-name="Dokument" *ngIf="!b2.filer.length">&ndash;</td>
                  <td data-name="Signatur" title="Signatur" class="text-center-sm-left">
                    <signature-icon [signature]="$safeNavigationMigration($safeNavigationMigration(b2.fil?.signatur))" *ngIf="b2.fil && ($safeNavigationMigration(b2.fil?.filtillagg) | lowercase) === '.pdf'"></signature-icon>
                  </td>
                  <td data-name="Vald" title="Vald" class="text-center-sm-left" *ngIf="role==='adv' && b2.fil && ($safeNavigationMigration(b2.fil?.filtillagg) | lowercase)==='.pdf'">
                    <div class="mb-0">
                      <div class="checkbox">
                        <label class="mb-0">
                          <input type="checkbox" class="form-check-input" [checked]="!!b2.isSelected || b2.fil?.signatur" [disabled]="$safeNavigationMigration(b2.fil?.signatur)" (change)="b2.isSelected = !b2.isSelected">
                          <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                        </label>
                      </div>
                    </div>
                  </td>
                  <td *ngIf="role==='adv' && (!b2.fil || ($safeNavigationMigration(b2.fil?.filtillagg) | lowercase)!=='.pdf')"></td>
                </tr>
              </tbody>
              <tfoot *ngIf="arende.b2Beslut.length > 1">
                <tr>
                  <th data-name="Antal" title="Antal {{ arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:or">{{ arende.b2Beslut.length | localizednumber }} st</th>
                  <th></th>
                  <th></th>
                  <th data-name="Total lönegaranti" title="Total lönegaranti" class="text-right-sm-left">{{ getSum(arende.b2Beslut, 'lgBeloppTotal') | localizednumber }} kr</th>
                  <th data-name="Totalt nettobelopp" title="Totalt nettobelopp" class="text-right-sm-left">{{ getSum(arende.b2Beslut, 'lgBeloppNetto') | localizednumber }} kr</th>
                  <th></th>
                  <th></th>
                  <th *ngIf="role==='adv'"></th>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="container-fluid" *ngIf="role==='adv' && harBeslutKvarAttSignera">
            <div class="row">
              <!-- button [disabled]="!selectedB2Besluts.length" (click)="attesteraBeslut()" class="btn-garanti btn-blue ms-auto"><fa-icon [icon]="['fas', 'marker']" class="me-2"></fa-icon>Attestera markerade {{ arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:or</button -->
              <sign [files]="selectedFiles" (onSuccess)="reloadArende()" class="d-flex w-100" btnClass="btn-garanti btn-blue ms-auto"></sign>
            </div>
          </div>
          <p class="text-muted" *ngIf="!arende.b2Beslut.length">Inga {{ arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:or/samlingsbeslut</p>
          <a [routerLink]="['/mina-arenden']" [queryParams]="{ previous: arende.id }" class="btn-garanti btn-blue mt-3"><fa-icon [icon]="['fas', 'arrow-left']" class="me-2"></fa-icon>Tillbaka till Mina ärenden</a>
        </div>
      </div>
    </div>
  </div>
</div>
